import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Images = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.55113 4.65642C2.41485 4.67598 2.32003 4.80204 2.33904 4.9384L3.51667 13.3851L6.85777 9.92016C7.08662 9.68283 7.44361 9.62278 7.73751 9.77217L9.61054 10.7243L11.9169 7.6685C12.1602 7.34625 12.6148 7.27436 12.9456 7.50585L14.8986 8.8726L14.1147 3.25045C14.0956 3.11331 13.9687 3.01784 13.8316 3.03751L2.55113 4.65642ZM15.1814 10.9014L12.6783 9.14964L10.4293 12.1293C10.2104 12.4195 9.81488 12.5108 9.49086 12.3461L7.55242 11.3608L3.79616 15.2562C3.79078 15.2618 3.78534 15.2673 3.77983 15.2727L3.84696 15.7542C3.86608 15.8913 3.99302 15.9868 4.13008 15.9671L9.76636 15.1582L15.4106 14.3482C15.5469 14.3287 15.6417 14.2026 15.6227 14.0662L15.1814 10.9014ZM0.853412 5.14553C0.720334 4.191 1.38407 3.30854 2.33805 3.17163L13.6185 1.55272C14.578 1.41503 15.4665 2.08337 15.6004 3.04332L15.6778 3.59853L18.3709 4.39701C19.2807 4.66674 19.8097 5.6124 19.5635 6.52883L16.7247 17.0966C16.477 18.0185 15.5363 18.5718 14.6102 18.3403L9.28394 17.0088C9.13906 16.9726 9.01465 16.8965 8.91949 16.7951L4.34317 17.4519C3.38376 17.5896 2.49517 16.9213 2.36133 15.9613L0.853412 5.14553ZM12.5373 16.2759L14.974 16.8851C15.1063 16.9182 15.2407 16.8391 15.276 16.7074L15.5064 15.8498L12.5373 16.2759ZM16.7437 11.244L18.1149 6.13967C18.1501 6.00876 18.0745 5.87366 17.9445 5.83513L15.9053 5.23053L16.7437 11.244ZM6.35933 6.88925C6.44144 7.46139 6.04419 7.99177 5.47205 8.07388C4.89991 8.15599 4.36953 7.75874 4.28742 7.18659C4.20531 6.61445 4.60256 6.08408 5.1747 6.00197C5.74684 5.91985 6.27722 6.3171 6.35933 6.88925Z"
        fill={color}
      />
    </svg>
  )
})

export default Images
